import { MODEL } from './types/model'
import { ARRAY } from './types/array'
import { FieldConfig, ArrayConfig, ModelConfig } from './decorators/constants'
import { TIME, DAY, DATETIME } from './types/time'

export const initializeValue = (rawValue: any, fieldConfig: FieldConfig, overrideType?: symbol) : any => {
  switch (overrideType || fieldConfig['$type']) {
    case MODEL: {
      const SubModel = (fieldConfig as ModelConfig).model
      if (!SubModel) {
        throw `Schemer.model requires a {model: <SchemerModel>} configuration entry`
      }
      return new SubModel(rawValue)
    }
    case ARRAY: {
      const arrayOfType = (fieldConfig as ArrayConfig).$arrayOfType
      return (rawValue || []).map(subVal => initializeValue(subVal, fieldConfig, arrayOfType))
    }
    case DAY:
    case TIME:
    case DATETIME:
      return rawValue ? new Date(rawValue) : null
    default:
      return rawValue
  }
}
